<!-- <dx-data-grid
  class="donor_list_data_grid"
  [dataSource]="allFundraisers"
  [showBorders]="false"
  [showColumnLines]="false"
  [showRowLines]="false"
  [allowColumnResizing]="true"
  columnResizingMode="widget"
  [focusedRowEnabled]="false"
  [rowAlternationEnabled]="false"
  rowTemplate="rowDonationList"
  [wordWrapEnabled]="true"
  [columnAutoWidth]="true"
>
  <dxo-paging [pageSize]="10" [pageIndex]="0"> </dxo-paging>
  <dxo-pager
    *ngIf="allFundraisers?.length > 10"
    [visible]="true"
    [showPageSizeSelector]="false"
    [allowedPageSizes]="[10]"
    [showInfo]="false"
    [showNavigationButtons]="true"
  >
  </dxo-pager>
  <dxi-column caption="Date & Time" dataField="date" alignment="left">
  </dxi-column>
  <dxi-column
    caption="Donor Name"
    dataField="donorName"
    alignment="left"
  ></dxi-column>
  <dxi-column
    caption="Amount"
    dataField="amount"
    alignment="center"
    style="border: none"
  >
  </dxi-column>
  <dxi-column caption="Account No" dataField="transactionId" alignment="left">
  </dxi-column>
  <dxi-column
    caption="Transaction Id"
    dataField="transactionId"
    alignment="center"
  >
  </dxi-column>
  <dxi-column
    caption="Status"
    dataField="status"
    alignment="center"
    style="border: none"
  >
  </dxi-column>

  <tbody class="bg-white" *dxTemplate="let row of 'rowDonationList'">
    <tr style="display: contents !important">
      <td>
        <div class="profile-details">
          <div class="donor-name text-start">
            {{ row?.data?.updated_at | date : "dd MMM yyyy" }}
          </div>
          <div class="donor-email text-start">
            {{ row?.data?.updated_at | date : "hh:mm a" }}
          </div>
        </div>
      </td>
      <td>
        <div class="donor-profile row_white">
          <div class="profile-avatar">
            <img
              class="profile_img"
              loading="lazy"
              [src]="
                row?.data?.profile_img || './assets/images/round_profile.png'
              "
              alt=""
            />
          </div>
          <div class="profile-details">
            <div class="fs_18 donor-name text-start c_0054a6">
              {{ row?.data?.donorName }}
            </div>
            <div class="donor-email fs_18 text-start">
              {{ "abulkalam@gmail.com" }}
            </div>
          </div>
        </div>
      </td>
      <td>
        <div class="donor-name">৳ {{ (row?.data?.amount | number) || 0 }}</div>
      </td>
      <td>
        <div class="profile-details text-start">
          <div class="donor-name c_0054a6">
            {{ row?.data?.phoneNumber }}
          </div>
          <div class="donor-email text-start">
            {{ row?.data?.paymentMethod }}
          </div>
        </div>
      </td>
      <td>
        <div class="donor-name c_0054a6">
          {{ row?.data?.transactionId }}
        </div>
      </td>
      <td>
        <div
          class="donor-name text-decoration-underline cursor fs-5"
          (click)="donationSummaryPopup = true"
          [ngStyle]="{
            color:
              row?.data?.status === 'Approved'
                ? '#039855'
                : row?.data?.status === 'Pending'
                ? '#ffd602'
                : '#D92D20'
          }"
        >
          ● {{ row?.data?.status }}
        </div>
      </td>
    </tr>
  </tbody>
</dx-data-grid> -->

<div class="filter_div_popup py-0 h-70">
  <div class="center_center gap-2">
    <div class="fs_18 mr-2">By Date Range:</div>
    <dx-date-range-box
      class="time_line"
      [startDate]="startDate"
      [endDate]="endDate"
      labelMode="floating"
      [min]="oneYearAgo"
      [max]="today"
      displayFormat="dd MMM, yyyy"
      (onValueChanged)="updateDateRange($event)"
    ></dx-date-range-box>
  </div>

  <!-- <div class="center_center gap-2">
    <div class="fs_18">By Campaign:</div>
    <dx-select-box class="inputField"></dx-select-box>
  </div> -->
  <!-- <div class="center_center justify-content-between gap-3">
    <div class="center_center gap-2">
      <div class="fs_18">By Status:</div>
      <dx-select-box
        [dataSource]="[
          { status: 'ALL' },
          { status: 'DONATED' },
          { status: 'PLEDGED' }
        ]"
        displayExpr="status"
        valueExpr="status"
        [(value)]="selectedStatus"
        placeholder="Select Status"
        class="chart-select"
      ></dx-select-box>
    </div>
  </div> -->
</div>
<dx-data-grid
  class="donor_list_data_grid"
  [dataSource]="recentActivity"
  [showBorders]="false"
  [showColumnLines]="false"
  [showRowLines]="false"
  [allowColumnResizing]="true"
  columnResizingMode="widget"
  [focusedRowEnabled]="false"
  [rowAlternationEnabled]="false"
  rowTemplate="rowDonationList"
  [wordWrapEnabled]="true"
  [columnAutoWidth]="true"
>
  <dxo-paging [pageSize]="10" [pageIndex]="0"> </dxo-paging>
  <dxo-pager
    *ngIf="allFundraisers?.length > 10"
    [visible]="true"
    [showPageSizeSelector]="false"
    [allowedPageSizes]="[10]"
    [showInfo]="false"
    [showNavigationButtons]="true"
  >
  </dxo-pager>
  <dxi-column
    caption="Donor Name"
    dataField="donorName"
    alignment="left"
  ></dxi-column>
  @if(selectedRole?.short_form === 'system_admin') {
  <dxi-column
    caption="Transaction Id"
    dataField="transactionId"
    alignment="center"
  >
  </dxi-column>
  }
  <dxi-column caption="Date & Time" dataField="date" alignment="center">
  </dxi-column>
  <dxi-column
    caption="Amount"
    dataField="amount"
    alignment="center"
    style="border: none"
  >
  </dxi-column>
  <dxi-column caption="Campaign" dataField="campaign" alignment="center">
  </dxi-column>
  <dxi-column
    caption="Status"
    dataField="status"
    alignment="center"
    style="border: none"
  >
  </dxi-column>
  <dxo-sorting mode="none"> </dxo-sorting>
  <tbody class="bg-white" *dxTemplate="let row of 'rowDonationList'">
    <tr style="display: contents !important">
      <td>
        <div class="donor-profile row_white">
          <div class="profile-avatar">
            <img
              class="profile_img"
              loading="lazy"
              [src]="
                row?.data?.profile_img || './assets/images/round_profile.png'
              "
              alt=""
            />
          </div>
          <div class="profile-details">
            <!-- (click)="routeToDonorInfo(row?.data?.donor_id)" -->
            <div class="donor-name fs_18 c_0054a6 cursor">
              {{ row?.data?.name }}
            </div>
            <!-- <div class="donor-email fs_18 text-start">
                    {{ row?.data?.phoneNumber }}
                  </div> -->
          </div>
        </div>
      </td>
      @if(selectedRole?.short_form === 'system_admin') {
      <td>
        <div class="profile-details">
          <div class="donor-email">
            {{ row?.data?.payment_method || "N/A" }}
          </div>
          <div class="donor-name c_0054a6 cursor text-decoration-underline">
            {{ row?.data?.transaction_id || "N/A" }}
          </div>
        </div>
      </td>
      }
      <td>
        <div class="profile-details">
          <div class="donor-name">
            {{ row?.data?.created_at | date : "dd MMM yyyy" }}
          </div>
          <div class="donor-email">
            {{ row?.data?.created_at | date : "hh:mm a" }}
          </div>
        </div>
      </td>
      <td>
        <div class="donor-name">৳ {{ (row?.data?.amount | number) || 0 }}</div>
      </td>
      <td>
        <div class="donor-name c_0054a6">
          {{ row?.data?.campaign_title }}
        </div>
      </td>
      <td>
        <div
          class="donor-name"
          [ngStyle]="{
            color:
              row?.data?.status === 'PAYMENT_PROCESSING'
                ? '#ffd700'
                : row?.data?.status === 'FAILED'
                ? '#D92D20'
                : row?.data?.status === 'REFUNDED'
                ? '#ff0062'
                : '#0054a6'
          }"
        >
          {{
            row?.data?.status === "PAYMENT_PROCESSING"
              ? "Payment Processing"
              : (row?.data?.status | titlecase)
          }}
        </div>
      </td>
    </tr>
  </tbody>
</dx-data-grid>

<!-- <dx-popup
  class="donor_activity"
  [(visible)]="donationSummaryPopup"
  [width]="'850px'"
  [height]="'650px'"
  [maxHeight]="'90vh'"
  [showTitle]="true"
  [showCloseButton]="true"
  [dragEnabled]="false"
  [resizeEnabled]="false"
  position="center"
  [enableBodyScroll]="false"
  [hideOnOutsideClick]="false"
>
  <div class="d-flex w-100 align-items-center flex-column">
    <div class="fs-3 fw-bold mb-4">Donation Approval Request Details</div>

    <div
      class="d-flex p-5 align-items-center flex-column"
      style="background-color: #f2f9ff"
    >
      <div class="w-100 d-flex">
        <div class="w-50">
          <div class="fs-4 mt-3">Donor Name</div>
          <div class="fs-4 fw-bold c_0054a6">Rahim Ahmed Khan</div>
          <div class="fs-4 mt-3">Donation Amount</div>
          <div class="fs-4 fw-bold">1000</div>
          <div class="fs-4 mt-3">Campaign</div>
          <div class="fs-4 fw-bold c_0054a6">Women Empowerment Program</div>
        </div>
        <div class="w-50">
          <div class="fs-4 mt-3">Transaction Id</div>
          <div class="fs-4 fw-bold">71NXMA9X | bKash</div>
          <div class="fs-4 mt-3">Account Number</div>
          <div class="fs-4 fw-bold">01786062801</div>
          <div class="fs-4 mt-3">Transaction Date</div>
          <div class="fs-4 fw-bold">June 15, 2022 | 09-12 PM</div>
        </div>
      </div>
      <div class="w-100 d-flex justify-content-center gap-4 mt-5">
        <button class="yellow-button-md">Reject</button>
        <button class="blue-button-md">Approve</button>
      </div>
    </div>
  </div>
</dx-popup> -->
